import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import type { StaffRole } from "@/shared/api/types";
import { useAuth } from "./AuthProvider";
import { EmptyState } from "@/shared/ui";

/** Guards a route by authentication and, optionally, by role. */
export function RequireAuth({ roles, children }: { roles?: StaffRole[]; children: ReactNode }) {
  const { user, hasRole } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (roles && !hasRole(...roles)) {
    return <EmptyState icon="lock" title="Không có quyền truy cập" description="Trang này chỉ dành cho quản trị viên. Liên hệ admin nếu bạn cần quyền này." />;
  }
  return <>{children}</>;
}
